import UnitsApi from '../../apis/Units';

export default {
    namespaced: true,
    state: {
        units: []
    },
    mutations: {
        set_units (state, data) {
            state.units = data;
        }
    },
    actions: {
        async getAllUnits ({commit}, filters) {
            return await UnitsApi.get_all(filters)
                .then( response => {
                    commit('set_units', response.data)
                })
                .catch( error => {
                    console.log(error);
                })
        }
    }
}